import React, { useEffect, useRef, useState } from 'react';
import { brandIdentity } from '../../data/mock';

const BrandSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-12 sm:py-16 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left: Logo Visual */}
          <div
            className={`relative transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'
            }`}
          >
            <div className="relative">
              {/* Background Elements */}
              <div className="absolute -top-8 -left-8 w-64 h-64 bg-[var(--brand-teal-100)] rounded-full blur-3xl opacity-50" />
              <div className="absolute -bottom-8 -right-8 w-48 h-48 bg-[var(--brand-teal-200)] rounded-full blur-3xl opacity-40" />
              
              {/* Logo Container */}
              <div className="relative bg-gradient-to-br from-[var(--brand-teal-50)] to-white rounded-3xl p-12 border border-[var(--brand-teal-100)] shadow-xl">
                <img
                  src="https://customer-assets.emergentagent.com/job_d7eb6b3f-f937-4d5e-8280-d403640a7122/artifacts/vdxv0syh_SuperHunt%20Logo%20Favicon.png"
                  alt="SuperHunt Geometric Falcon"
                  className="w-48 h-48 mx-auto object-contain animate-float"
                />
                <div className="text-center mt-6">
                  <h3 className="heading-3 gradient-text">{brandIdentity.logoName}</h3>
                  <p className="body-small mt-1">Our Identity</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Brand Philosophy */}
          <div
            className={`transition-all duration-700 delay-200 ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'
            }`}
          >
            <div className="inline-flex items-center gap-2 bg-[var(--brand-teal-50)] border border-[var(--brand-teal-100)] rounded-full px-4 py-2 mb-6">
              <span className="text-sm font-medium text-[var(--brand-teal-700)]">Our Identity</span>
            </div>
            
            <h2 className="heading-1 mb-6">
              Engineered for <span className="gradient-text">Intelligent Pursuit</span>
            </h2>
            
            <p className="body-large mb-8">
              {brandIdentity.philosophy}
            </p>

            {/* Principles */}
            <div className="space-y-6">
              {brandIdentity.principles.map((principle, index) => (
                <div
                  key={index}
                  className="group flex gap-4 p-4 rounded-xl bg-gradient-to-r from-[var(--brand-teal-50)] to-transparent border border-transparent hover:border-[var(--brand-teal-100)] transition-all"
                >
                  <div className="w-12 h-12 rounded-xl bg-[var(--brand-teal-100)] flex items-center justify-center flex-shrink-0 group-hover:bg-[var(--brand-teal-200)] transition-colors">
                    <span className="text-xl font-bold text-[var(--brand-teal-700)]">
                      {index + 1}
                    </span>
                  </div>
                  <div>
                    <h4 className="heading-3 text-lg mb-1">{principle.title}</h4>
                    <p className="body-small">{principle.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandSection;
